import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import {
  type ContactSupportMutationVariables,
  ContactSupportDocument,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';

const useContactSupport = () => {
  const [contactSupportMutation] = useMutation(ContactSupportDocument);

  const contactSupport = useCallback(
    async (variables: ContactSupportMutationVariables) => {
      try {
        await contactSupportMutation({
          variables: { ...variables },
        });
      } catch (error) {
        throw withRaw(toGraphqlError(error), error);
      }
    },
    [contactSupportMutation],
  );

  return contactSupport;
};

export default useContactSupport;
